import { render, staticRenderFns } from "./CustomerOrderItemList.vue?vue&type=template&id=3b69e00e&scoped=true"
import script from "./CustomerOrderItemList.vue?vue&type=script&lang=js"
export * from "./CustomerOrderItemList.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrderItemList.vue?vue&type=style&index=0&id=3b69e00e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b69e00e",
  null
  
)

export default component.exports